import axios from "axios";


export const BASE_URLOld = "https://indie4x4-backend-9bff9eabafde.herokuapp.com/api/v1";
export const BASE_URL = "https://api.indie4x4.com/api/v1";

const _config = {};

function extractErrorMessage(error) {
  const apiMessage = error?.response?.data?.message;
  if (typeof apiMessage === "string") {
    return apiMessage;
  }
  if (Array.isArray(apiMessage) && apiMessage.length > 0) {
    if (apiMessage[0]?.property) {
      return `Problem with field: ${apiMessage[0].property}, value: ${apiMessage[0].value}`;
    }
    return apiMessage.join(", ");
  }
  return error?.message || "API error";
}

export async function put(url, data) {
  if (
    localStorage.getItem("token") !== null &&
    localStorage.getItem("token") !== undefined
  ) {
    axios.defaults.headers.common[
      "authorization"
    ] = `Bearer ${localStorage.getItem("token")}`;
  }
  try {
    const response = await axios.put(url, data, _config);
    return response;
  }
  catch (error) {
    throw new Error(extractErrorMessage(error));
  }
}

export async function patch(url, data) {
  if (
    localStorage.getItem("token") !== null &&
    localStorage.getItem("token") !== undefined
  ) {
    axios.defaults.headers.common[
      "authorization"
    ] = `Bearer ${localStorage.getItem("token")}`;
  }
  try {
    const response = await axios.patch(url, data, _config);
    return response;
  }
  catch (error) {
    throw new Error(extractErrorMessage(error));
  }
}

export async function post(url, data) {
  if (
    localStorage.getItem("token") !== null &&
    localStorage.getItem("token") !== undefined
  ) {
    axios.defaults.headers.common[
      "authorization"
    ] = `Bearer ${localStorage.getItem("token")}`;
  }
  try {
    const response = await axios.post(url, data);
    return response;
  } catch (error) {
    throw new Error(extractErrorMessage(error));
  }
}

export async function get(url, config = {}) {
  if (
    localStorage.getItem("token") !== null &&
    localStorage.getItem("token") !== undefined
  ) {
    axios.defaults.headers.common[
      "authorization"
    ] = `Bearer ${localStorage.getItem("token")}`;
  }
  config = {
    ..._config,
    ...config,
  };
  try {
    const response = await axios.get(url, config);
    return response.data;
  } catch (error) {
    throw new Error(extractErrorMessage(error));
  }
}

export async function deleteCall(url, config = {}) {
  if (
    localStorage.getItem("token") !== null &&
    localStorage.getItem("token") !== undefined
  ) {
    axios.defaults.headers.common[
      "authorization"
    ] = `Bearer ${localStorage.getItem("token")}`;
  }
  config = {
    ..._config,
    ...config,
  };
  try {
    const response = await axios.delete(url, config);
    return response.data;
  } catch (error) {
    throw new Error(extractErrorMessage(error));
  }
}
